import { Fragment, ReactElement } from "react";

import {
  getOrderChipClassName,
  TOrderSide,
} from "./entity-property-items-change.utils";
import { SearchHighlight } from "./search-highlight";

interface IEntityPropertyOrderProps {
  order: string[];
  side: TOrderSide;
  moved: Set<string>;
  otherSide: Set<string>;
}

/** One side of a reorder: the stations as chips joined by arrows, `−` for the old order and `+` for the new one. */
export const EntityPropertyOrder = ({
  order,
  side,
  moved,
  otherSide,
}: IEntityPropertyOrderProps): ReactElement => (
  <div className="entityProperty__chips">
    <span className="entityProperty__order-caption" aria-hidden="true">
      {side === "before" ? "−" : "+"}
    </span>
    {order.map((item, index) => (
      <Fragment key={item}>
        {index > 0 && (
          <span className="entityProperty__chip-arrow" aria-hidden="true">
            →
          </span>
        )}
        <SearchHighlight
          className={getOrderChipClassName({ item, side, moved, otherSide })}
          text={item}
        />
      </Fragment>
    ))}
  </div>
);
